class CustomRegistrationService {
  $http: ng.IHttpService;
  private registrationUserData: any = null;

  constructor($http) {
    this.$http = $http;
  }

  find(id: number) {
    return this.$http.get(`/api/v1/custom_registrations/${id}`);
  }

  // Store user data temporarily during registration flow
  setRegistrationUserData(userData: any) {
    this.registrationUserData = userData;
  }

  // Retrieve and clear stored user data
  getRegistrationUserData(): any {
    const data = this.registrationUserData;
    this.registrationUserData = null; // Clear after retrieval
    return data;
  }

  // Build embedded form URL with template variable replacement and UTM params
  buildEmbeddedFormUrl(embeddedForm: string, user: any, utmParams: any = {}): string {
    if (!embeddedForm || !user) return '';

    let url = this.extractUrlFromEmbeddedForm(embeddedForm);

    url = url
      .replace('$name$', encodeURIComponent(user.name))
      .replace('$id$', encodeURIComponent(user.platform_id || user.platformId))
      .replace('$email$', encodeURIComponent(user.email));

    if (Object.keys(utmParams).length > 0) {
      const separator = url.includes('?') ? '&' : '?';
      const queryString = Object.entries(utmParams)
        .map(([key, value]) => `${key}=${encodeURIComponent(value as string)}`)
        .join('&');
      url = `${url}${separator}${queryString}`;
    }

    return url;
  }

  // Extract URL from embedded form (handles both URL strings and iframe HTML)
  private extractUrlFromEmbeddedForm(embeddedForm: string): string {
    if (!embeddedForm) return '';

    if (embeddedForm.trim().startsWith('<iframe')) {
      const srcMatch = embeddedForm.match(/src=["']([^"']+)["']/i);
      return srcMatch ? srcMatch[1] : '';
    }

    return embeddedForm;
  }
}

CustomRegistrationService.$inject = ['$http'];

export default CustomRegistrationService;
